export const productName = 'MINING & MINERAL RESOURCES TEACHER READY';
export const productShortName = 'Mining & Mineral Resources Teacher Ready';
export const productImage = 'https://cdn.magicpatterns.com/uploads/29EoFv5qoMek6qgEcRXFhs/MOCKUP_5.23.04_p._m..png';

export const checkoutUrl = 'https://mining-mineral-resources-teacher-ready.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const included = [
  'Volume 1 — Mining & Mineral Resources Fundamentals',
  'Volume 2 — Geology, Minerals & Ore Deposits',
  'Volume 3 — Mineral Exploration & Resource Evaluation',
  'Volume 4 — Surface Mining Methods & Operations',
  'Volume 5 — Underground Mining Methods & Operations',
  'Volume 6 — Mineral Processing & Value Recovery',
  'Volume 7 — Mine Safety, Risk Management & Occupational Health',
  'Volume 8 — Environmental Management, Sustainability & Mine Closure',
  'Volume 9 — Teaching Mining & Mineral Resources',
  'Bonus 1 — 150 Classroom Activities & Challenges',
  'Bonus 2 — Mining & Mineral Resources Assessment Bank',
  'Bonus 3 — 100 Case Studies & Real-World Scenarios',
  'Bonus 4 — 50 Mining & Mineral Resources Classroom Projects & Challenges',
  "Bonus 5 — Mining & Mineral Resources Teacher's Concept & Terminology Guide",
  '7-day money-back guarantee',
  'Instant access',
];

export const systemNegatives = [
  "It's not outdated theory copied from old textbooks.",
  "It's not a collection of disconnected activities.",
  "It's not material you'll need to completely rewrite.",
];

export const closingLines = [
  'No more sleepless nights searching for ways to explain complex mining concepts',
  "No more rushed lessons with materials that don't work",
  "No more disconnected students who don't see mining's relevance",
  'No more weekends spent building lesson plans from scratch',
  "No more awkward silences when students ask technical questions you weren't ready for",
];
